import { CHART_COLOR_PALLETTE } from 'utils/constants';
import { ICellRendererParams, ICurrencyFormat } from 'utils/types';
import {
  cellCurrencyRendererFramework,
  varianceCurrencyCellRendererFramework,
} from '../TableComponents';

export const getColumnDefs = (
  columnDateLabels: string[],
  format: ICurrencyFormat
) => [
  {
    headerName: 'SPEND ITEM',
    field: 'title',
    tooltipField: 'title',
    width: 128,
    sortable: true,
    headerComponentParams: { hideIcon: true },
  },
  {
    headerName: 'VENDOR',
    field: 'vendor',
    tooltipField: 'vendor',
    width: 104,
    sortable: true,
    headerComponentParams: { hideIcon: true },
  },
  {
    headerName: 'SERVICE TOWER',
    field: 'serviceTower',
    tooltipField: 'serviceTower',
    width: 128,
    sortable: true,
    headerComponentParams: { hideIcon: true },
  },
  {
    headerName: 'EXPENSE TYPE',
    field: 'expenseType',
    tooltipField: 'expenseType',
    width: 104,
    sortable: true,
    headerComponentParams: { hideIcon: true },
  },
  {
    headerName: 'TOTAL',
    headerGroupComponent: 'customHeaderGroupComponent',
    children: [
      {
        headerName: columnDateLabels[0],
        field: 'totalCurrYear',
        width: 80,
        headerComponentParams: {
          color: CHART_COLOR_PALLETTE[0],
        },
        sortable: true,
        type: 'numericColumn',
        cellRendererFramework: (params: ICellRendererParams) =>
          cellCurrencyRendererFramework(params, format),
      },
      {
        headerName: columnDateLabels[1],
        field: 'totalPrevYear',
        width: 80,
        type: 'numericColumn',
        headerComponentParams: {
          color: CHART_COLOR_PALLETTE[1],
        },
        sortable: true,
        cellRendererFramework: (params: ICellRendererParams) =>
          cellCurrencyRendererFramework(params, format),
      },
      {
        headerName: 'CHANGE',
        field: 'totalChange',
        type: 'numericColumn',
        width: 92,
        sortable: true,
        cellRendererFramework: (params: ICellRendererParams) =>
          varianceCurrencyCellRendererFramework(params, format),
      },
    ],
  },
];

export const useTableData = (
  columnDateLabels: string[],
  format: ICurrencyFormat
) => {
  return {
    columnDefs: getColumnDefs(columnDateLabels, format),
  };
};
